// test98
(98 && 0);
